import React from 'react';

export type IconProps = React.SVGProps<SVGSVGElement>;

let svgIdSequence = 0;
const nextSvgId = () => {
  svgIdSequence += 1;
  return `amenities_svg_${svgIdSequence}`;
};

const RefrigeratorIcon: React.FC<IconProps> = (props) => (
  <svg viewBox="0 0 32 32" aria-hidden="true" role="presentation" focusable="false" {...props}>
    <title>Refrigerator</title>
    <path d="M25 1a2 2 0 0 1 2 1.85V29a2 2 0 0 1-1.85 2H7a2 2 0 0 1-2-1.85V3a2 2 0 0 1 1.85-2H7zm0 10H7v18h18zm-15 2a1 1 0 1 1 0 2 1 1 0 0 1 0-2zM25 3H7v6h18zM10 5a1 1 0 1 1 0 2 1 1 0 0 1 0-2z" />
  </svg>
);

const TvIcon: React.FC<IconProps> = (props) => (
  <svg viewBox="0 0 32 32" aria-hidden="true" role="presentation" focusable="false" {...props}>
    <path d="M9 29v-2h2v-2H6a5 5 0 0 1-5-4.78V8a5 5 0 0 1 4.78-5H26a5 5 0 0 1 5 4.78V20a5 5 0 0 1-4.78 5H21v2h2v2zm10-4h-6v2h6zm7-20H6a3 3 0 0 0-3 2.82V20a3 3 0 0 0 2.82 3H26a3 3 0 0 0 3-2.82V8a3 3 0 0 0-2.82-3z" />
  </svg>
);

const CoffeeIcon: React.FC<IconProps> = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 32 32"
    aria-hidden="true"
    role="presentation"
    focusable="false"
    {...props}
  >
    <title>Coffee</title>
    <path d="M25 2a1 1 0 0 1 .94.65l.03.1 1 4A1 1 0 0 1 26.11 8L26 8h-9v2h-2V8H5v20h3a5 5 0 0 1-.72-4.66l.1-.26 2.52-6.04-1.8-3.6a1 1 0 0 1 .78-1.43L9 12h14a1 1 0 0 1 .94 1.34l-.05.1L22.62 16H24a5 5 0 0 1 5 4.78V25h-2v-4a3 3 0 0 0-2.82-3H22.5l2.12 5.08A5 5 0 0 1 24 28h3v2H4a1 1 0 0 1-1-.88V3a1 1 0 0 1 .88-1H4zM12.65 22a6.64 6.64 0 0 0-2.91.63l-.5 1.22a3 3 0 0 0-.2.68l-.03.23L9 25a3 3 0 0 0 2.82 3h8.19l.23-.01a3 3 0 0 0 2.6-2.02c-1.7-.12-2.93-.67-4.84-1.9l-.37-.23c-2.14-1.4-3.18-1.84-4.98-1.84zm7.68-4h-8.66l-.92 2.19a9.06 9.06 0 0 1 1.9-.19c2.19 0 3.51.52 5.75 1.95l.38.25c1.74 1.13 2.74 1.62 4.03 1.76l-.04-.11zm1.05-4H10.62l1 2h8.76zm2.84-10H5v2h19.72z" />
  </svg>
);

const BurgerIcon: React.FC<IconProps> = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 32 32"
    aria-hidden="true"
    role="presentation"
    focusable="false"
    {...props}
  >
    <title>Burger</title>
    <path d="M16 5c6.1 0 11 3.58 11 8v1H5v-1c0-4.42 4.9-8 11-8zm0 2C11.2 7 7.3 9.53 7.03 12H25c-.28-2.47-4.2-5-9-5zm-12 9h24a2 2 0 0 1 2 1.85V19a4 4 0 0 1-3.8 4H6a4 4 0 0 1-4-3.8V18a2 2 0 0 1 1.85-2H4zm2 2v1a2 2 0 0 0 1.85 2H26a2 2 0 0 0 2-1.85V18H6zm-2 7h24v2H4v-2z" />
  </svg>
);

const LeafIcon: React.FC<IconProps> = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 32 32"
    aria-hidden="true"
    role="presentation"
    focusable="false"
    {...props}
  >
    <title>Leaf</title>
    <path d="M27 4c-7.74 0-13.4 2.38-16.83 5.8C6.41 13.56 5 18.6 5 24a1 1 0 0 0 1 1c5.4 0 10.44-1.41 14.2-5.17C23.62 16.4 26 10.74 26 3a1 1 0 0 0-1-1zm-8.21 14.41C15.6 21.6 11.45 22.86 7.1 22.99c.12-4.35 1.39-8.5 4.58-11.69C14.8 8.18 19.57 6.2 24 6.02c-.18 4.43-2.16 9.2-5.21 12.39z" />
    <path d="M9.29 23.71a1 1 0 0 1 0-1.42l10-10a1 1 0 0 1 1.42 1.42l-10 10a1 1 0 0 1-1.42 0z" />
  </svg>
);

const KitchenIcon: React.FC<IconProps> = (props) => (
  <svg viewBox="0 0 32 32" aria-hidden="true" role="presentation" focusable="false" {...props}>
    <path d="M26 1a5 5 0 0 1 5 5c0 6.39-1.6 13.19-4 14.7V31h-2V20.7c-2.36-1.48-3.94-8.07-4-14.36v-.56A5 5 0 0 1 26 1zm-9 0v18.12c2.32.55 4 3 4 5.88 0 3.27-2.18 6-5 6s-5-2.73-5-6c0-2.87 1.68-5.33 4-5.88V1zM2 1h1c4.47 0 6.93 6.37 7 18.5V21H4v10H2zm14 20c-1.6 0-3 1.75-3 4s1.4 4 3 4 3-1.75 3-4-1.4-4-3-4zM4 3.24V19h4l-.02-.96-.03-.95C7.67 9.16 6.24 4.62 4.22 3.36L4.1 3.3zm19 2.58v.49c.05 4.32 1.03 9.13 2 11.39V3.17a3 3 0 0 0-2 2.65zm4-2.65V17.7c.99-2.31 2-7.3 2-11.7a3 3 0 0 0-2-2.83z" />
  </svg>
);

const StudioIcon: React.FC<IconProps> = (props) => (
  <svg viewBox="0 0 32 32" aria-hidden="true" role="presentation" focusable="false" {...props}>
    <path d="M26 2a1 1 0 0 1 .92.61l.04.12 2 7a1 1 0 0 1-.85 1.26L28 11h-3v5h6v2h-2v13h-2v-2.54a3.98 3.98 0 0 1-1.73.53L25 29H7a3.98 3.98 0 0 1-2-.54V31H3V18H1v-2h5v-4a1 1 0 0 1 .88-1h.36L6.09 8.4l1.82-.8L9.43 11H12a1 1 0 0 1 1 .88V16h10v-5h-3a1 1 0 0 1-.99-1.16l.03-.11 2-7a1 1 0 0 1 .84-.72L22 2h4zm1 16H5v7a2 2 0 0 0 1.7 1.98l.15.01L7 27h18a2 2 0 0 0 2-1.85V18zm-16-5H8v3h3v-3zm14.24-9h-2.49l-1.43 5h5.35l-1.43-5z" />
  </svg>
);

const MicrowaveIcon: React.FC<IconProps> = (props) => (
  <svg viewBox="0 0 32 32" aria-hidden="true" role="presentation" focusable="false" {...props}>
    <path d="M29 3a2 2 0 0 1 2 1.85V27a2 2 0 0 1-1.85 2H3a2 2 0 0 1-2-1.85V5a2 2 0 0 1 1.85-2H3zm0 2H3v22h26zm-6 2v18H5V7zm-2 2H7v14h3a4.97 4.97 0 0 1-1-2.72V17h10v3a4.98 4.98 0 0 1-1 3h3zm-4 10h-6v1a3 3 0 0 0 2.65 2.98l.17.01.18.01a3 3 0 0 0 3-2.82V20zm9-8a1 1 0 1 1 0 2 1 1 0 0 1 0-2zm0-4a1 1 0 1 1 0 2 1 1 0 0 1 0-2z" />
  </svg>
);

const OvenIcon: React.FC<IconProps> = (props) => (
  <svg viewBox="0 0 32 32" aria-hidden="true" role="presentation" focusable="false" {...props}>
    <path d="M28 2a2 2 0 0 1 2 1.85V28a2 2 0 0 1-1.85 2H4a2 2 0 0 1-2-1.85V4a2 2 0 0 1 1.85-2H4zm0 10H4v16h24zm-2 2v12H6V14zm-2 2H8v8h16zm4-12H4v6h24zm-3 2a1 1 0 1 1 0 2 1 1 0 0 1 0-2zm-6 0a1 1 0 1 1 0 2 1 1 0 0 1 0-2zm-6 0a1 1 0 1 1 0 2 1 1 0 0 1 0-2zM7 6a1 1 0 1 1 0 2 1 1 0 0 1 0-2z" />
  </svg>
);

const CleaningIcon: React.FC<IconProps> = (props) => (
  <svg viewBox="0 0 32 32" aria-hidden="true" role="presentation" focusable="false" {...props}>
    <path d="M24 0v6h-4.3c.13 1.4.67 2.72 1.52 3.78l.2.22-1.5 1.33a9.05 9.05 0 0 1-2.2-5.08c-.83.38-1.32 1.14-1.38 2.2v4.46l4.14 4.02a5 5 0 0 1 1.5 3.09l.01.25.01.25v8.63a3 3 0 0 1-2.64 2.98l-.18.01-.21.01-12-.13A3 3 0 0 1 4 29.2L4 29.02v-8.3a5 5 0 0 1 1.38-3.45l.19-.18L10 12.9V8.85l-4.01-3.4.02-.7A5 5 0 0 1 10.78 0H11zm-5.03 25.69a8.98 8.98 0 0 1-6.13-2.41l-.23-.23A6.97 6.97 0 0 0 6 21.2v7.82c0 .51.38.93.87 1H7l11.96.13h.13a1 1 0 0 0 .91-.88l.01-.12v-3.52c-.34.04-.69.06-1.03.06zM17.67 2H11a3 3 0 0 0-2.92 2.3l-.04.18-.01.08 3.67 3.1h2.72l.02-.1a4.29 4.29 0 0 1 3.23-3.4zM30 4a1 1 0 1 1 0 2 1 1 0 0 1 0-2zm-3-2a1 1 0 1 1 0 2 1 1 0 0 1 0-2zm-5 0h-2.33v2H22zm8-2a1 1 0 1 1 0 2 1 1 0 0 1 0-2zM20 20.52a3 3 0 0 0-.77-2l-.14-.15-4.76-4.61v-4.1H12v4.1l-5.06 4.78a3 3 0 0 0-.45.53 9.03 9.03 0 0 1 7.3 2.34l.23.23A6.98 6.98 0 0 0 20 23.6z" />
  </svg>
);

const ToiletriesIcon: React.FC<IconProps> = (props) => (
  <svg viewBox="0 0 32 32" aria-hidden="true" role="presentation" focusable="false" {...props}>
    <path d="M20 1v2h-3v2h1a2 2 0 0 1 2 1.85V9a4 4 0 0 1 4 3.8V27a4 4 0 0 1-3.8 4H12a4 4 0 0 1-4-3.8V13a4 4 0 0 1 3.8-4h.2V7a2 2 0 0 1 1.85-2H15V3H8V1zm2 21H10v5a2 2 0 0 0 1.85 2H20a2 2 0 0 0 2-1.85V27zm0-6H10v4h12zm-2-5h-8a2 2 0 0 0-2 1.85V14h12v-1a2 2 0 0 0-2-2zm-2-4h-4v2h4z" />
  </svg>
);

const WifiIcon: React.FC<IconProps> = (props) => (
  <svg viewBox="0 0 32 32" aria-hidden="true" role="presentation" focusable="false" {...props}>
    <path d="M16 20.33a3.67 3.67 0 1 1 0 7.34 3.67 3.67 0 0 1 0-7.34zm0 2a1.67 1.67 0 1 0 0 3.34 1.67 1.67 0 0 0 0-3.34zM16 15a9 9 0 0 1 8.04 4.96l-1.51 1.51a7 7 0 0 0-13.06 0l-1.51-1.51A9 9 0 0 1 16 15zm0-5.33c4.98 0 9.37 2.54 11.94 6.4l-1.45 1.44a12.33 12.33 0 0 0-20.98 0l-1.45-1.45A14.32 14.32 0 0 1 16 9.66zm0-5.34c6.45 0 12.18 3.1 15.76 7.9l-1.43 1.44a17.64 17.64 0 0 0-28.66 0L.24 12.24c3.58-4.8 9.3-7.9 15.76-7.9z" />
  </svg>
);

const AcIcon: React.FC<IconProps> = (props) => (
  <svg viewBox="0 0 32 32" aria-hidden="true" role="presentation" focusable="false" {...props}>
    <path d="M17 1v4.03l4.03-2.32 1 1.73L17 7.34v6.93l6-3.47V5h2v4.65l3.49-2.02 1 1.74L26 11.38l4.03 2.33-1 1.73-5.03-2.9L18 16l6 3.46 5.03-2.9 1 1.73L26 20.62l3.49 2.01-1 1.74L25 22.35V27h-2v-5.8l-6-3.47v6.93l5.03 2.9-1 1.73L17 26.97V31h-2v-4.03l-4.03 2.32-1-1.73 5.03-2.9v-6.93L9 21.2V27H7v-4.65l-3.49 2.02-1-1.74L6 20.62l-4.03-2.33 1-1.73L8 19.46 14 16l-6-3.46-5.03 2.9-1-1.73L6 11.38 2.51 9.37l1-1.74L7 9.65V5h2v5.8l6 3.47V7.34l-5.03-2.9 1-1.73L15 5.03V1z" />
  </svg>
);

const LockIcon: React.FC<IconProps> = (props) => (
  <svg viewBox="0 0 32 32" aria-hidden="true" role="presentation" focusable="false" {...props}>
    <path d="M25 1a2 2 0 0 1 2 1.85V29h2v2H3v-2h2V3a2 2 0 0 1 1.85-2H7zm0 2H7v26h18zm-9 6a3 3 0 0 1 3 2.82V14a5 5 0 1 1-6 0v-2a3 3 0 0 1 3-3zm0 6a3 3 0 1 0 0 6 3 3 0 0 0 0-6zm0 2a1 1 0 1 1 0 2 1 1 0 0 1 0-2zm0-6a1 1 0 0 0-1 .88V13.1a5.02 5.02 0 0 1 2 0V12a1 1 0 0 0-1-1z" />
  </svg>
);

const ElevatorIcon: React.FC<IconProps> = (props) => (
  <svg
    viewBox="0 0 20 20"
    aria-hidden="true"
    role="presentation"
    focusable="false"
    {...props}
    fill="none"
  >
    <path
      d="M2 4.62891C2 2.41977 3.79086 0.628906 6 0.628906H14C16.2091 0.628906 18 2.41977 18 4.62891V14.6289C18 16.838 16.2091 18.6289 14 18.6289H6C3.79086 18.6289 2 16.838 2 14.6289V4.62891Z"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M5.58824 18.6289V9.47506C5.58824 9.17741 5.85176 8.9366 6.17647 8.9366H14.4118C14.7365 8.9366 15 9.17741 15 9.47506V18.6289M10.2941 8.9366V18.6289M5 6.78275L6.76471 4.62891L8.52941 6.78275M15 4.62891L13.2353 6.78275L11.4706 4.62891"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const PoolIcon: React.FC<IconProps> = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 32 32"
    aria-hidden="true"
    role="presentation"
    focusable="false"
    {...props}
  >
    <path d="M24 26c.99 0 1.95.35 2.67 1 .3.29.71.45 1.14.5H28v2h-.23a3.96 3.96 0 0 1-2.44-1A1.98 1.98 0 0 0 24 28c-.5 0-.98.17-1.33.5a3.98 3.98 0 0 1-2.67 1 3.98 3.98 0 0 1-2.67-1A1.98 1.98 0 0 0 16 28c-.5 0-.98.17-1.33.5a3.98 3.98 0 0 1-2.67 1 3.98 3.98 0 0 1-2.67-1A1.98 1.98 0 0 0 8 28c-.5 0-.98.17-1.33.5a3.96 3.96 0 0 1-2.44 1H4v-2h.19a1.95 1.95 0 0 0 1.14-.5A3.98 3.98 0 0 1 8 26c.99 0 1.95.35 2.67 1 .35.33.83.5 1.33.5.5 0 .98-.17 1.33-.5A3.97 3.97 0 0 1 16 26c.99 0 1.95.35 2.67 1 .35.33.83.5 1.33.5.5 0 .98-.17 1.33-.5A3.98 3.98 0 0 1 24 26zm0-5c.99 0 1.95.35 2.67 1 .3.29.71.45 1.14.5H28v2h-.23a3.96 3.96 0 0 1-2.44-1A1.98 1.98 0 0 0 24 23c-.5 0-.98.17-1.33.5a3.98 3.98 0 0 1-2.67 1 3.98 3.98 0 0 1-2.67-1A1.98 1.98 0 0 0 16 23c-.5 0-.98.17-1.33.5a3.98 3.98 0 0 1-2.67 1 3.98 3.98 0 0 1-2.67-1A1.98 1.98 0 0 0 8 23c-.5 0-.98.17-1.33.5a3.96 3.96 0 0 1-2.44 1H4v-2h.19a1.95 1.95 0 0 0 1.14-.5A3.98 3.98 0 0 1 8 21c.99 0 1.95.35 2.67 1 .35.33.83.5 1.33.5.5 0 .98-.17 1.33-.5A3.97 3.97 0 0 1 16 21c.99 0 1.95.35 2.67 1 .35.33.83.5 1.33.5.5 0 .98-.17 1.33-.5A3.98 3.98 0 0 1 24 21zM20 3a4 4 0 0 1 4 3.8V9h4v2h-4v5a4 4 0 0 1 2.5.86l.17.15c.3.27.71.44 1.14.48l.19.01v2h-.23a3.96 3.96 0 0 1-2.44-1A1.98 1.98 0 0 0 24 18c-.5 0-.98.17-1.33.5a3.98 3.98 0 0 1-2.67 1 3.98 3.98 0 0 1-2.67-1A1.98 1.98 0 0 0 16 18c-.5 0-.98.17-1.33.5a3.98 3.98 0 0 1-2.67 1 3.98 3.98 0 0 1-2.67-1A1.98 1.98 0 0 0 8 18c-.5 0-.98.17-1.33.5a3.96 3.96 0 0 1-2.44 1H4v-2h.19a1.95 1.95 0 0 0 1.14-.5A3.98 3.98 0 0 1 8 16c.99 0 1.95.35 2.67 1 .35.33.83.5 1.33.5.5 0 .98-.17 1.33-.5a3.96 3.96 0 0 1 2.44-1H16v-5H4V9h12V7a2 2 0 0 0-4-.15V7h-2a4 4 0 0 1 7-2.65A3.98 3.98 0 0 1 20 3zm-2 13.52.46.31.21.18c.35.31.83.49 1.33.49a2 2 0 0 0 1.2-.38l.13-.11c.2-.19.43-.35.67-.49V11h-4zM20 5a2 2 0 0 0-2 1.85V9h4V7a2 2 0 0 0-2-2z" />
  </svg>
);

const BeachIcon: React.FC<IconProps> = (props) => {
  const reactId = React.useMemo(() => nextSvgId(), []);
  const clipId = `clip0_2_1369_${reactId}`;
  const mask0Id = `mask0_2_1369_${reactId}`;
  const mask1Id = `mask1_2_1369_${reactId}`;

  return (
    <svg
      viewBox="0 0 45 45"
      aria-hidden="true"
      role="presentation"
      focusable="false"
      {...props}
      fill="none"
    >
      <title>Beach</title>
      <g clipPath={`url(#${clipId})`}>
        <path
          d="M26.496 18.771C26.371 15.501 23.569 12.693 18.282 10.257L17.5 9.90399L16.718 10.257C11.308 12.75 8.5 15.632 8.5 19V20L10.5 19.999H12.5H22.5H24.5L26.5 20V19L26.496 18.771ZM10.635 18L10.655 17.929L10.717 17.734C11.368 15.846 13.492 14 17.194 12.242L17.5 12.099L17.806 12.242L18.183 12.424C21.776 14.188 23.796 16.039 24.345 17.929L24.364 18H10.635Z"
          fill="currentColor"
        />
        <path
          d="M23.5 24.997H11.494V18.999H23.5V24.997Z"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path d="M18.5 24.75H16.5V22H18.5V24.75Z" fill="currentColor" />
        <path
          d="M31.954 13.189C32.33 14.583 32.5 16.123 32.5 18C32.5 20.346 31.902 22.682 30.717 25L28.437 24.999C29.817 22.646 30.5 20.316 30.5 18C30.5 16.075 30.31 14.587 29.893 13.259C30.812 11.5 31.5 11.5 31.954 13.189Z"
          fill="currentColor"
        />
        <path
          d="M31.6 11.04C33.734 11.324 30.31 14.587 29.893 13.259C29.114 13.644 28.565 14.423 28.505 15.336L28.5 15.5H26.5C26.5 13.55 27.74 11.891 29.474 11.265C29.325 10.579 31.857 10.457 31.6 11.04Z"
          fill="currentColor"
        />
        <path
          d="M31.6 11.04C33.734 11.324 35.394 13.103 35.495 15.288L35.5 15.5H33.5C33.5 14.457 32.862 13.564 31.954 13.189C31.308 12.716 30.795 12.453 29.474 11.265C29.325 10.579 31.857 10.457 31.6 11.04Z"
          fill="currentColor"
        />
        <path
          d="M31.6 11.04C31.408 11.13 30.311 11.561 29.474 11.265C29.325 10.579 28.526 10 27.5 10C26.416 10 25.587 10.646 25.506 11.383L25.5 11.5H23.5C23.5 9.523 25.327 8 27.5 8C28.682 8 29.762 8.451 30.501 9.18C31.239 8.45 31.857 10.457 31.6 11.04Z"
          fill="currentColor"
        />
        <mask id={mask0Id} maskUnits="userSpaceOnUse" x="-17" y="-18" width="80" height="81">
          <path d="M63 -17.5H-17V62.5H63V-17.5Z" fill="#F2DDBB" />
        </mask>
        <g mask={`url(#${mask0Id})`}>
          <path
            d="M31.556 28C32.675 28.001 33.757 28.411 34.572 29.176C34.962 29.541 35.473 29.76 36.016 29.804L36.222 29.812V31.812C35.103 31.812 34.021 31.401 33.205 30.636C32.767 30.225 32.175 30 31.556 30C30.936 30 30.344 30.225 29.906 30.636C29.09 31.401 28.008 31.812 26.889 31.812C25.85 31.812 24.842 31.458 24.051 30.795L23.872 30.636C23.433 30.225 22.842 30 22.222 30C21.602 30 21.011 30.225 20.573 30.636C19.757 31.401 18.674 31.812 17.555 31.812C16.436 31.812 15.354 31.401 14.538 30.636C14.1 30.225 13.509 30 12.889 30C12.269 30 11.678 30.225 11.239 30.636C10.481 31.346 9.49399 31.752 8.46099 31.806L8.22198 31.812V29.812C8.77298 29.812 9.30099 29.634 9.71999 29.306L9.87198 29.176C10.688 28.411 11.77 28.001 12.889 28C14.008 28.001 15.09 28.411 15.906 29.176C16.344 29.587 16.935 29.812 17.555 29.812C18.175 29.812 18.766 29.588 19.205 29.176C20.021 28.412 21.103 28.001 22.222 28C23.341 28.001 24.423 28.411 25.239 29.176C25.678 29.587 26.269 29.812 26.889 29.812C27.509 29.812 28.1 29.587 28.538 29.176C29.354 28.411 30.436 28.001 31.556 28Z"
            fill="currentColor"
          />
          <path
            d="M59.209 28C60.328 28.001 61.41 28.411 62.225 29.176C62.615 29.541 63.126 29.76 63.669 29.804L63.875 29.812V31.812C62.756 31.812 61.674 31.401 60.858 30.636C60.42 30.225 59.828 30 59.209 30C58.589 30 57.997 30.225 57.559 30.636C56.743 31.401 55.661 31.812 54.542 31.812C53.503 31.812 52.495 31.458 51.704 30.795L51.525 30.636C51.086 30.225 50.495 30 49.875 30C49.255 30 48.664 30.225 48.226 30.636C47.41 31.401 46.327 31.812 45.208 31.812C44.089 31.812 43.007 31.401 42.191 30.636C41.753 30.225 41.162 30 40.542 30C39.922 30 39.331 30.225 38.892 30.636C38.134 31.346 37.147 31.752 36.114 31.806L35.875 31.812V29.812C36.426 29.812 36.954 29.634 37.373 29.306L37.525 29.176C38.341 28.411 39.423 28.001 40.542 28C41.661 28.001 42.743 28.411 43.559 29.176C43.997 29.587 44.588 29.812 45.208 29.812C45.828 29.812 46.419 29.588 46.858 29.176C47.674 28.412 48.756 28.001 49.875 28C50.994 28.001 52.076 28.411 52.892 29.176C53.331 29.587 53.922 29.812 54.542 29.812C55.162 29.812 55.753 29.587 56.191 29.176C57.007 28.411 58.089 28.001 59.209 28Z"
            fill="currentColor"
          />
          <path
            d="M3.709 28C4.828 28.001 5.91 28.411 6.725 29.176C7.115 29.541 7.626 29.76 8.169 29.804L8.375 29.812V31.812C7.256 31.812 6.174 31.401 5.358 30.636C4.92 30.225 4.328 30 3.709 30C3.089 30 2.497 30.225 2.059 30.636C1.243 31.401 0.160999 31.812 -0.958 31.812C-1.997 31.812 -3.005 31.458 -3.796 30.795L-3.975 30.636C-4.414 30.225 -5.005 30 -5.625 30C-6.245 30 -6.836 30.225 -7.274 30.636C-8.09 31.401 -9.173 31.812 -10.292 31.812C-11.411 31.812 -12.493 31.401 -13.309 30.636C-13.747 30.225 -14.338 30 -14.958 30C-15.578 30 -16.169 30.225 -16.608 30.636C-17.366 31.346 -18.353 31.752 -19.386 31.806L-19.625 31.812V29.812C-19.074 29.812 -18.546 29.634 -18.127 29.306L-17.975 29.176C-17.159 28.411 -16.077 28.001 -14.958 28C-13.839 28.001 -12.757 28.411 -11.941 29.176C-11.503 29.587 -10.912 29.812 -10.292 29.812C-9.672 29.812 -9.081 29.588 -8.642 29.176C-7.826 28.412 -6.744 28.001 -5.625 28C-4.506 28.001 -3.424 28.411 -2.608 29.176C-2.169 29.587 -1.578 29.812 -0.958 29.812C-0.337999 29.812 0.253 29.587 0.691 29.176C1.507 28.411 2.589 28.001 3.709 28Z"
            fill="currentColor"
          />
        </g>
        <mask id={mask1Id} x="-17" y="-18" width="80" height="81">
          <path d="M63 -17.5H-17V62.5H63V-17.5Z" fill="#F2DDBB" />
        </mask>
        <g mask={`url(#${mask1Id})`}>
          <path
            d="M31.556 33C32.675 33.001 33.757 33.411 34.572 34.176C34.962 34.541 35.473 34.76 36.016 34.804L36.222 34.812V36.812C35.103 36.812 34.021 36.401 33.205 35.636C32.767 35.225 32.175 35 31.556 35C30.936 35 30.344 35.225 29.906 35.636C29.09 36.401 28.008 36.812 26.889 36.812C25.85 36.812 24.842 36.458 24.051 35.795L23.872 35.636C23.433 35.225 22.842 35 22.222 35C21.602 35 21.011 35.225 20.573 35.636C19.757 36.401 18.674 36.812 17.555 36.812C16.436 36.812 15.354 36.401 14.538 35.636C14.1 35.225 13.509 35 12.889 35C12.269 35 11.678 35.225 11.239 35.636C10.481 36.346 9.49399 36.752 8.46099 36.806L8.22198 36.812V34.812C8.77298 34.812 9.30099 34.634 9.71999 34.306L9.87198 34.176C10.688 33.411 11.77 33.001 12.889 33C14.008 33.001 15.09 33.411 15.906 34.176C16.344 34.587 16.935 34.812 17.555 34.812C18.175 34.812 18.766 34.588 19.205 34.176C20.021 33.412 21.103 33.001 22.222 33C23.341 33.001 24.423 33.411 25.239 34.176C25.678 34.587 26.269 34.812 26.889 34.812C27.509 34.812 28.1 34.587 28.538 34.176C29.354 33.411 30.436 33.001 31.556 33Z"
            fill="currentColor"
          />
          <path
            d="M59.209 33C60.328 33.001 61.41 33.411 62.225 34.176C62.615 34.541 63.126 34.76 63.669 34.804L63.875 34.812V36.812C62.756 36.812 61.674 36.401 60.858 35.636C60.42 35.225 59.828 35 59.209 35C58.589 35 57.997 35.225 57.559 35.636C56.743 36.401 55.661 36.812 54.542 36.812C53.503 36.812 52.495 36.458 51.704 35.795L51.525 35.636C51.086 35.225 50.495 35 49.875 35C49.255 35 48.664 35.225 48.226 35.636C47.41 36.401 46.327 36.812 45.208 36.812C44.089 36.812 43.007 36.401 42.191 35.636C41.753 35.225 41.162 35 40.542 35C39.922 35 39.331 35.225 38.892 35.636C38.134 36.346 37.147 36.752 36.114 36.806L35.875 36.812V34.812C36.426 34.812 36.954 34.634 37.373 34.306L37.525 34.176C38.341 33.411 39.423 33.001 40.542 33C41.661 33.001 42.743 33.411 43.559 34.176C43.997 34.587 44.588 34.812 45.208 34.812C45.828 34.812 46.419 34.588 46.858 34.176C47.674 33.412 48.756 33.001 49.875 33C50.994 33.001 52.076 33.411 52.892 34.176C53.331 34.587 53.922 34.812 54.542 34.812C55.162 34.812 55.753 34.587 56.191 34.176C57.007 33.411 58.089 33.001 59.209 33Z"
            fill="currentColor"
          />
          <path
            d="M3.709 33C4.828 33.001 5.91 33.411 6.725 34.176C7.115 34.541 7.626 34.76 8.169 34.804L8.375 34.812V36.812C7.256 36.812 6.174 36.401 5.358 35.636C4.92 35.225 4.328 35 3.709 35C3.089 35 2.497 35.225 2.059 35.636C1.243 36.401 0.160999 36.812 -0.958 36.812C-1.997 36.812 -3.005 36.458 -3.796 35.795L-3.975 35.636C-4.414 35.225 -5.005 35 -5.625 35C-6.245 35 -6.836 35.225 -7.274 35.636C-8.09 36.401 -9.173 36.812 -10.292 36.812C-11.411 36.812 -12.493 36.401 -13.309 35.636C-13.747 35.225 -14.338 35 -14.958 35C-15.578 35 -16.169 35.225 -16.608 35.636C-17.366 36.346 -18.353 36.752 -19.386 36.806L-19.625 36.812V34.812C-19.074 34.812 -18.546 34.634 -18.127 34.306L-17.975 34.176C-17.159 33.411 -16.077 33.001 -14.958 33C-13.839 33.001 -12.757 33.411 -11.941 34.176C-11.503 34.587 -10.912 34.812 -10.292 34.812C-9.672 34.812 -9.081 34.588 -8.642 34.176C-7.826 33.412 -6.744 33.001 -5.625 33C-4.506 33.001 -3.424 33.411 -2.608 34.176C-2.169 34.587 -1.578 34.812 -0.958 34.812C-0.337999 34.812 0.253 34.587 0.691 34.176C1.507 33.411 2.589 33.001 3.709 33Z"
            fill="currentColor"
          />
        </g>
      </g>
      <defs>
        <clipPath id={clipId}>
          <rect width="45" height="45" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

const LinensAndTowelsIcon: React.FC<IconProps> = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 32 32"
    aria-hidden="true"
    role="presentation"
    focusable="false"
    {...props}
  >
    <path d="M19.59 2a2 2 0 0 1 1.28.47l.13.12L29.41 11a2 2 0 0 1 .58 1.24l.01.17V25a5 5 0 0 1-4.78 5H4a2 2 0 0 1-2-1.85V7a5 5 0 0 1 4.78-5H7zM7 4a3 3 0 0 0-3 2.82V21a3 3 0 0 0 2.82 3H26v2H7a4.98 4.98 0 0 1-3-1v3h21a3 3 0 0 0 3-2.82V22H6v-2h22v-6h-5a5 5 0 0 1-5-4.78V4zm20.59 8L20 4.42V9a3 3 0 0 0 2.82 3H23z" />
  </svg>
);

const LibraryIcon: React.FC<IconProps> = (props) => (
  <svg viewBox="0 0 32 32" aria-hidden="true" role="presentation" focusable="false" {...props}>
    <path d="M1.67 2.68A2 2 0 0 1 4.1.72l.14.04L16.01 4.3 27.78.91a2 2 0 0 1 2.53 1.63l.02.14v23.25a2 2 0 0 1-1.27 1.85l-.15.06-12.62 3.78a1 1 0 0 1-.46.03l-.12-.03L3.1 27.84a2 2 0 0 1-1.42-1.75v-.17zm2 0v23.24L16 29.62l12.33-3.7V2.82L16.28 6.3a1 1 0 0 1-.46.03l-.1-.03zm21.66 17.48v2.08L16 25.04v-2.08zm0-6v2.08L16 19.04v-2.08zm0-6v2.08L16 13.04v-2.08z" />
  </svg>
);

const LobbyIcon: React.FC<IconProps> = (props) => {
  const reactId = React.useMemo(() => nextSvgId(), []);
  const clipId = `clip0_945_63756_${reactId}`;

  return (
    <svg
      viewBox="0 0 24 24"
      aria-hidden="true"
      role="presentation"
      focusable="false"
      {...props}
      fill="none"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <title>Lobby</title>
      <g clipPath={`url(#${clipId})`}>
        <path
          d="M18.1172 6.09771C18.972 6.73439 19.5775 7.18601 20.0283 7.58187C20.4709 7.97044 20.7223 8.26988 20.8883 8.58197C21.2299 9.22379 21.25 9.9579 21.25 11.9512V13.4425C21.25 15.4842 21.2478 16.9275 21.076 18.0211C20.9097 19.0796 20.5989 19.7054 20.0479 20.177C19.48 20.6629 18.6982 20.949 17.4006 21.0983C16.092 21.2488 14.3752 21.25 12 21.25C9.62477 21.25 7.90802 21.2488 6.59936 21.0983C5.30184 20.949 4.51999 20.6629 3.9521 20.177C3.40107 19.7054 3.09027 19.0796 2.92397 18.0211C2.75216 16.9275 2.75 15.4842 2.75 13.4425L2.75 11.9512C2.75 9.9579 2.77014 9.22379 3.11165 8.58197C3.27772 8.26988 3.52908 7.97044 3.97165 7.58187C4.42254 7.18601 5.02796 6.73438 5.88276 6.09771C7.46192 4.92152 8.59405 4.07985 9.56227 3.52469C10.5111 2.98066 11.2398 2.75 12 2.75C12.7602 2.75 13.489 2.98066 14.4377 3.52469C15.4059 4.07985 16.5381 4.92152 18.1172 6.09771Z"
          strokeWidth="1.5"
        />
        <path
          d="M9.25 20.5V15.375C9.25 14.5603 9.25 14.153 9.36691 13.8262C9.56865 13.2624 10.0124 12.8186 10.5762 12.6169C10.903 12.5 11.3103 12.5 12.125 12.5V12.5C12.9397 12.5 13.347 12.5 13.6738 12.6169C14.2376 12.8186 14.6814 13.2624 14.8831 13.8262C15 14.153 15 14.5603 15 15.375V20.5"
          strokeWidth="1.5"
        />
      </g>
      <defs>
        <clipPath id={clipId}>
          <rect width="24" height="24" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

const HomeIcon: React.FC<IconProps> = (props) => {
  const reactId = React.useMemo(() => nextSvgId(), []);
  const clipId = `clip0_945_63756_home_${reactId}`;

  return (
    <svg
      viewBox="0 0 24 24"
      aria-hidden="true"
      role="presentation"
      focusable="false"
      {...props}
      fill="none"
    >
      <g clipPath={`url(#${clipId})`}>
        <path
          d="M18.1172 6.09771C18.972 6.73439 19.5775 7.18601 20.0283 7.58187C20.4709 7.97044 20.7223 8.26988 20.8883 8.58197C21.2299 9.22379 21.25 9.9579 21.25 11.9512V13.4425C21.25 15.4842 21.2478 16.9275 21.076 18.0211C20.9097 19.0796 20.5989 19.7054 20.0479 20.177C19.48 20.6629 18.6982 20.949 17.4006 21.0983C16.092 21.2488 14.3752 21.25 12 21.25C9.62477 21.25 7.90802 21.2488 6.59936 21.0983C5.30184 20.949 4.51999 20.6629 3.9521 20.177C3.40107 19.7054 3.09027 19.0796 2.92397 18.0211C2.75216 16.9275 2.75 15.4842 2.75 13.4425L2.75 11.9512C2.75 9.9579 2.77014 9.22379 3.11165 8.58197C3.27772 8.26988 3.52908 7.97044 3.97165 7.58187C4.42254 7.18601 5.02796 6.73438 5.88276 6.09771C7.46192 4.92152 8.59405 4.07985 9.56227 3.52469C10.5111 2.98066 11.2398 2.75 12 2.75C12.7602 2.75 13.489 2.98066 14.4377 3.52469C15.4059 4.07985 16.5381 4.92152 18.1172 6.09771Z"
          stroke="currentColor"
          strokeWidth="1.5"
        />
        <path
          d="M9.25 20.5V15.375C9.25 14.5603 9.25 14.153 9.36691 13.8262C9.56865 13.2624 10.0124 12.8186 10.5762 12.6169C10.903 12.5 11.3103 12.5 12.125 12.5V12.5C12.9397 12.5 13.347 12.5 13.6738 12.6169C14.2376 12.8186 14.6814 13.2624 14.8831 13.8262C15 14.153 15 14.5603 15 15.375V20.5"
          stroke="currentColor"
          strokeWidth="1.5"
        />
      </g>
      <defs>
        <clipPath id={clipId}>
          <rect width="24" height="24" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

const DefaultAmenityIcon: React.FC<IconProps> = (props) => (
  <svg viewBox="0 0 32 32" aria-hidden="true" role="presentation" focusable="false" {...props}>
    <title>Amenity</title>
    <path d="M16 2a14 14 0 1 1 0 28 14 14 0 0 1 0-28zm0 2a12 12 0 1 0 0 24 12 12 0 0 0 0-24zm-4.5 7h9a2.5 2.5 0 0 1 2.5 2.5v7A2.5 2.5 0 0 1 20.5 23h-9A2.5 2.5 0 0 1 9 20.5v-7A2.5 2.5 0 0 1 11.5 11zm0 2A.5.5 0 0 0 11 13.5v7c0 .28.22.5.5.5h9c.28 0 .5-.22.5-.5v-7a.5.5 0 0 0-.5-.5h-9z" />
  </svg>
);

const GymIcon: React.FC<IconProps> = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 32 32"
    aria-hidden="true"
    role="presentation"
    focusable="false"
    fill="#292A2B"
    {...props}
  >
    <path d="M10 5a2 2 0 0 1 2 1.85V15h8V7a2 2 0 0 1 1.85-2H24a2 2 0 0 1 2 1.85V9h2a2 2 0 0 1 2 1.85V15h2v2h-2v4a2 2 0 0 1-1.85 2H26v2a2 2 0 0 1-1.85 2H22a2 2 0 0 1-2-1.85V17h-8v8a2 2 0 0 1-1.85 2H8a2 2 0 0 1-2-1.85V23H4a2 2 0 0 1-2-1.85V17H0v-2h2v-4a2 2 0 0 1 1.85-2H6V7a2 2 0 0 1 1.85-2H8zm14 2h-2v18h2zM10 7H8v18h2zm18 4h-2v10h2zM6 11H4v10h2z"></path>
  </svg>
);

const DishWasherIcon: React.FC<IconProps> = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 32 32"
    aria-hidden="true"
    role="presentation"
    focusable="false"
    {...props}
  >
    <path d="M28 2a2 2 0 0 1 2 1.85V28a2 2 0 0 1-1.85 2H4a2 2 0 0 1-2-1.85V4a2 2 0 0 1 1.85-2H4zm0 10H4v16h24zm-2 2v4a3 3 0 0 1-2 2.83V24h2v2h-6v-2h2v-3.17a3 3 0 0 1-2-2.65V14zm-14 0a6 6 0 1 1 0 12 6 6 0 0 1 0-12zm0 2a4 4 0 1 0 0 8 4 4 0 0 0 0-8zm12 0h-2v2a1 1 0 0 0 .77.97l.11.02.12.01a1 1 0 0 0 1-.88V18zm4-12H4v6h24zm-6 2v2H10V6zM7 6a1 1 0 1 1 0 2 1 1 0 0 1 0-2z" />
  </svg>
);

const FreeParkingIcon: React.FC<IconProps> = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 32 32"
    aria-hidden="true"
    role="presentation"
    focusable="false"
    {...props}
  >
    <path d="M26 19a1 1 0 1 1-2 0 1 1 0 0 1 2 0zM7 18a1 1 0 1 0 0 2 1 1 0 0 0 0-2zm20.7-5 .41 1.12A4.97 4.97 0 0 1 30 18v9a2 2 0 0 1-2 2h-2a2 2 0 0 1-2-2v-2H8v2a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2v-9c0-1.57.75-2.96 1.89-3.88L4.3 13H2v-2h3v.15L6.82 6.3A2 2 0 0 1 8.69 5h14.62c.83 0 1.58.52 1.87 1.3L27 11.15V11h3v2h-2.3zM6 25H4v2h2v-2zm22 0h-2v2h2v-2zm0-2v-5a3 3 0 0 0-3-3H7a3 3 0 0 0-3 3v5h24zm-3-10h.56L23.3 7H8.69l-2.25 6H25zm-15 7h12v-2H10v2z" />
  </svg>
);

const SharedRooftopIcon: React.FC<IconProps> = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 32 32"
    aria-hidden="true"
    role="presentation"
    focusable="false"
    {...props}
  >
    <path d="M29 15v16h-2v-6h-6v6h-2v-6.15a2 2 0 0 1 1.84-1.84L21 23h6v-8zM5 15v8h6a2 2 0 0 1 2 1.85V31h-2v-6H5v6H3V15zM16 1a15 15 0 0 1 13.56 8.57 1 1 0 0 1-.8 1.42l-.1.01H17v8h8v2h-8v10h-2V21H7v-2h8v-8H3.35a1 1 0 0 1-.95-1.32l.04-.1A15 15 0 0 1 16 1zm0 2A13 13 0 0 0 5.4 8.47l-.2.28-.16.25h21.92l-.17-.25a13 13 0 0 0-10.1-5.73L16.34 3z" />
  </svg>
);

const PatioIcon: React.FC<IconProps> = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 32 32"
    aria-hidden="true"
    role="presentation"
    focusable="false"
    {...props}
  >
    <path d="M23 1a2 2 0 0 1 2 1.85V19h4v2h-2v8h2v2H3v-2h2v-8H3v-2h4V3a2 2 0 0 1 1.85-2H9zM9 21H7v8h2zm4 0h-2v8h2zm4 0h-2v8h2zm4 0h-2v8h2zm4 0h-2v8h2zm-10-8H9v6h6zm8 0h-6v6h6zM15 3H9v8h6zm8 0h-6v8h6z" />
  </svg>
);

export const AmenitiesIcons = {
  default: HomeIcon,
  refrigerator: RefrigeratorIcon,
  tv: TvIcon,
  coffee: CoffeeIcon,
  minceBurgers: BurgerIcon,
  zest: LeafIcon,
  kitchen: KitchenIcon,
  studio: StudioIcon,
  microwave: MicrowaveIcon,
  oven: OvenIcon,
  cleaning: CleaningIcon,
  toiletries: ToiletriesIcon,
  wifi: WifiIcon,
  ac: AcIcon,
  lock: LockIcon,
  pool: PoolIcon,
  beach: BeachIcon,
  linensAndTowels: LinensAndTowelsIcon,
  library: LibraryIcon,
  lobby: LobbyIcon,
  home: HomeIcon,
  elevator: ElevatorIcon,
  gym: GymIcon,
  dishWasher: DishWasherIcon,
  freeParking: FreeParkingIcon,
  patio: PatioIcon,
  sharedRooftop: SharedRooftopIcon
} as const;

export type AmenityIconKey = keyof typeof AmenitiesIcons;

const COLOR_ONLY_AMENITY_ICONS: ReadonlySet<AmenityIconKey> = new Set<AmenityIconKey>([
  'home',
  'lobby',
  'elevator',
  'beach'
]);

export const amenitiesIconsByName: Record<string, AmenityIconKey> = {
  lobby: 'lobby',
  refrigerator: 'refrigerator',
  'smart tv': 'tv',
  library: 'library',
  'smart lock': 'lock',
  'coffee corner': 'coffee',
  'mince burgers': 'minceBurgers',
  zest: 'zest',
  kitchen: 'kitchen',
  'dish washer': 'dishWasher',
  'workout studio': 'studio',
  microwave: 'microwave',
  oven: 'oven',
  'weekly cleaning': 'cleaning',
  toiletries: 'toiletries',
  wifi: 'wifi',
  ac: 'ac',
  elevator: 'elevator',
  pool: 'pool',
  beach: 'beach',
  'linens and towels': 'linensAndTowels',
  'free parking': 'freeParking',
  patio: 'patio',
  'shared rooftop': 'sharedRooftop',
  gym: 'gym',
  home: 'home',
  'dj awadly': 'home'
  // Keep unknown/brand names mapped explicitly if needed
};

export const getAmenityIconKey = (amenityName?: string): AmenityIconKey | undefined => {
  const normalized = (amenityName ?? '').trim().toLowerCase();
  if (!normalized) return 'default';
  return amenitiesIconsByName[normalized] ?? 'default';
};

export const AmenityIcon: React.FC<{ amenityName?: string } & IconProps> = ({
  amenityName,
  style,
  fill,
  ...props
}) => {
  const key = getAmenityIconKey(amenityName);
  if (!key) return null;

  const Icon = AmenitiesIcons[key];

  const shouldMapFillToColor = COLOR_ONLY_AMENITY_ICONS.has(key);

  return (
    <Icon
      {...props}
      style={{
        ...(shouldMapFillToColor && { fill: 'none' })
      }}
    />
  );
};
